"use strict";

define('components/carousel',[], function() {

    var carousel = {

        init: function (node) {
            var self = this;

            // Initialize photo-carousel
            var carouselContainer = node.find('.photo-carousel');
            if (carouselContainer.length > 0) {
                self.activeImageLoaded(node);
            }

            // Initialize photo-carousel-responsive
            var carouselContainerResponsive = node.find('.photo-carousel-responsive');
            if (carouselContainerResponsive.length > 0) {

                var carouselNode = carouselContainerResponsive.find('.carousel-inner');
                carouselNode.height(self.getCarouselHeight(carouselContainerResponsive));

                $(window).resize({'container': carouselContainerResponsive[0], 'self': self}, self.processResize);

                var carouselActiveImage = carouselContainerResponsive.find('.carousel-inner .item.active > img');
                if (typeof(carouselActiveImage.naturalWidth) != 'undefined' ||
                    typeof(carouselActiveImage.attr('width') != 'undefined')) {
                    self.processResize(null, carouselActiveImage[0], carouselContainerResponsive, self);
                    if (typeof(carouselActiveImage.naturalWidth) != 'undefined') {
                        self.activeImageLoaded(node);
                    }
                }

                var carouselImages = carouselContainerResponsive.find('.carousel-inner .item > img');
                carouselImages.on('load', function() {
                    self.processResize(null, this, carouselContainerResponsive, self);
                    if ($(this).attr('src') == carouselActiveImage.attr('src')) {
                        self.activeImageLoaded(node);
                    }
                });
            }

            // Hide filmstrip on touch devices
            if (Modernizr.touch) {
                node.find('.film-strip-wrapper').hide();
                return;
            }

            // Add scroll overlays to filmstrip if needed
            var carouselItem = node.find('.film-strip-wrapper').each(function(idx) {
                var filmStrip = $(this);
                var filmStripWidth = filmStrip.outerWidth();

                filmStrip.find('img').one('load', function() {
                    var listWidth = 0;
                    filmStrip.find('li').each(function(idx){
                        listWidth += $(this).outerWidth();
                    });

                    if (filmStripWidth > listWidth ) {
                        return;
                    }
                    filmStrip.find('.film-strip-control').removeClass('hidden');
                });
            });

            // Click handlers for images and controls in the film strip
            node.find('.film-strip-wrapper').click(function(e) {
                e.preventDefault();
                e.stopPropagation();
                var carouselId = $(this).data('carousel-id');
                var carousel = $('#'+carouselId);
                if (e.target.tagName == 'IMG') {
                    var itemIndex = $(e.target).closest('li').data('idx');
                    self.selectCarouselItem(carousel, itemIndex);
                    self.setFilmStripSelection($(e.target).closest('.film-strip-wrapper'), itemIndex)
                } else if (e.target.tagName == 'SPAN') {
                    var direction = $(e.target).closest('a').data('direction');
                    self.scrollFilmStrip($(this), direction);
                }
            });

            // Link events in the bootstrap carousel to the filmstrip
            node.find('.film-strip-wrapper').each(function(idx) {
                var filmStrip = $(this);
                var carouselId = filmStrip.data('carousel-id');
                var carousel = $('#'+carouselId);
                carousel.on('slide.bs.carousel', function (e) {
                    self.setFilmStripSelection(filmStrip, $(e.relatedTarget).index());
                });
            });
        },

        getCarouselHeight: function(carouselContainer) {
            var isLightbox = carouselContainer.closest('.lightbox-body').length == 1;

            if (isLightbox) {
                var desiredHeight = $(window).height() - $('.lightbox-header').outerHeight();
                desiredHeight -= 20;  // Reserve space for 10px padding
                if (!Modernizr.touch) {
                    // Film strip is hidden on touch devices
                    var filmStripHeight = carouselContainer.find('.film-strip-wrapper').outerHeight();
                    desiredHeight -= filmStripHeight
                }
            } else {
                var desiredHeight = $(window).height() - filmStripHeight;
                desiredHeight -= 31;  // Reserve space for 15px padding and 1px border
            }
            return desiredHeight;
        },

        activeImageLoaded: function(node) {
            // Hide the 'loading' spinner and load all delayed images after page has been rendered.
            node.find('.photo-carousel-responsive.loading').removeClass('loading');

            node.find('img.delayed-load').each(function() {
                $(this).attr('src', $(this).data('src'));
            });
        },

        resizeTimeout: null,

        processResize: function (e, imgNode, carouselContainer, self) {
            if (e != null) {
                carouselContainer = $(e.data.container);
                self = e.data.self;
            }

            if(this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
                this.resizeTimeout = null;
            }

            var carouselHeight = self.getCarouselHeight(carouselContainer);
            if (carouselHeight == 0) {
                return;
            }

            var carouselNode = $(carouselContainer).find('.carousel-inner');
            if(imgNode) {
                carouselNode.height(carouselHeight);
                setImageProperties(imgNode, carouselNode.width(), carouselHeight);
            } else {
                this.resizeTimeout = setTimeout(function () {
                    carouselNode.height(carouselHeight);
                    carouselNode.find('.item > img').each(function(idx, imgNode) {
                        setImageProperties(imgNode, carouselNode.width(), carouselHeight);
                    });
                }, 10);
            }
        },

        selectCarouselItem: function (carousel, itemIndex) {
            var currentCarouselItem = carousel.find('.carousel-inner > div.item.active');
            var carouselItem = $(carousel.find('.carousel-inner > div.item')[itemIndex]);
            if (!carouselItem.hasClass('active')) {
                carouselItem.addClass('active');
                currentCarouselItem.removeClass('active');
            }
        },

        scrollFilmStrip: function (filmStripWrapper, direction) {
            var filmStrip = filmStripWrapper.find('.film-strip');
            var leftPos = filmStrip.scrollLeft();
            if (leftPos == 0 && direction == 1) {
                return;
            }
            var offset = 0;
            var filmStripWidth = filmStrip.outerWidth();
            $('.film-strip').find('li').each(function(idx){
                var itemOffset = $(this).position().left;
                if (direction == 1 &&  itemOffset >= filmStripWidth * -1) {
                    // When paginating left, find the first item on the previous page and scroll left until it is the
                    // first item in the filmstrip.
                    offset = this.offsetLeft;
                    return false;
                } else if (direction == -1 && itemOffset + $(this).outerWidth() >= filmStripWidth) {
                    // When paginating right, find the first item (partially) hidden and scroll right until it is
                    // the first item in the filmstrip.
                    offset = this.offsetLeft;
                    return false;
                }
            });
            filmStrip.animate({scrollLeft: offset});
        },

        setFilmStripSelection: function (filmStripWrapper, index) {
            var currentFilmStripItem = $('.film-strip').find('li.active');
            if (currentFilmStripItem.hasClass('active')) {
                currentFilmStripItem.removeClass('active');
            }

            var filmStripItem = $($('.film-strip').find('li').get(index));
            if (!filmStripItem.hasClass('active')) {
                filmStripItem.addClass('active');
            }

            var filmStrip = filmStripWrapper.find('.film-strip');
            var filmStripWidth = filmStrip.outerWidth();
            if (filmStripItem.position().left + filmStripItem.outerWidth() > filmStripWidth) {
                this.scrollFilmStrip(filmStripWrapper, -1);
            } else if (filmStripItem.position().left < 0) {
                this.scrollFilmStrip(filmStripWrapper, 1);
            }
        }
    };


    var setImageProperties = function(imgNode, containerWidth, containerHeight) {
        var rawWidth = imgNode.naturalWidth || parseInt($(imgNode).attr('width'), 10);
        var rawHeight = imgNode.naturalHeight || parseInt($(imgNode).attr('height'), 10);
        var aspectRatio = rawWidth / rawHeight;
        var imgHeight = containerWidth / aspectRatio;
        if (imgHeight > rawHeight) {
            imgHeight = rawHeight;
        }
        var desiredHeight = Math.min(imgHeight, containerHeight);
        $(imgNode).height(desiredHeight);

        var topOffset = 10;
        if (desiredHeight < containerHeight ) {
            topOffset += (containerHeight - desiredHeight)/2;
        }
        $(imgNode).css({top: topOffset+'px'});
        $(imgNode).parent().find('.carousel-caption').css({top: (desiredHeight + topOffset - 90)+'px'});
    }

    return carousel;
});

